// src/pages/Courses/CourseCreatePage.tsx
import React from 'react';
import CourseForm from '../../components/Course/CourseForm';
import { createCourse } from '../../services/courseService';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuthoringAssistantCreateState } from '../../components/AI/authoringAssistantNavigation';

const CourseCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const assistantCreateState = getAuthoringAssistantCreateState(location.state, 'course');

  const handleCreate = async (data: { name: string; description: string; startDate: string; endDate: string; subject: string; subjectSpecification: string }) => {
    await createCourse(data);
    navigate('/course');
  };

  return (
    <div>
      <h1>Luo kurssi</h1>
      <CourseForm
        onSubmit={handleCreate}
        assistantInitialPrompt={assistantCreateState.prompt}
        assistantAutoGenerate={assistantCreateState.autoGenerate}
      />
    </div>
  );
};

export default CourseCreatePage;
